import { buildApiUrl, API_CONFIG } from './api-config';

export interface InterestedUserData {
  email: string;
}

export interface InterestedUserResponse {
  success: boolean;
  data?: {
    id: string;
    email: string;
    created_at: string;
  };
  error?: string;
  message: string;
}

export const addInterestedUser = async (
  userData: InterestedUserData
): Promise<InterestedUserResponse> => {
  try {
    const response = await fetch(buildApiUrl(API_CONFIG.ENDPOINTS.INTERESTED_USERS.ADD), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(userData),
    });

    const data = await response.json();

    if (!response.ok) {
      return {
        success: false,
        error: data.error || 'Failed to add interested user',
        message: data.message || 'An error occurred while adding your email',
      };
    }

    return data;
  } catch (error) {
    console.error('Error adding interested user:', error);
    return {
      success: false,
      error: 'Network error',
      message: 'Failed to connect to the server. Please try again.',
    };
  }
};
